var map = {
	"./01_beeldjes_maria_gabriel.yaml": "4DxY",
	"./02_doksaal.yaml": "VVkv",
	"./03_grafmonument_carondelet.yaml": "fmU9",
	"./04_kalvarie_catharina_barbara.yaml": "FEkr",
	"./05_koorgestoelte.yaml": "hko9",
	"./06_kromstafbekroning.yaml": "cUwJ",
	"./07_kruisbeeld.yaml": "q/1c",
	"./08_laatste_avondmaal.yaml": "TEiF",
	"./09_marteling_hippolytus.yaml": "HZiI",
	"./10_passieretabel.yaml": "15YH",
	"./11_passietaferelen.yaml": "8edo",
	"./12_retabel_anna.yaml": "j3zO",
	"./13_schrijn_karel_de_goede.yaml": "QtHa",
	"./14_schrijn_sint_elooi.yaml": "/Qt4",
	"./15_tronende_madonna.yaml": "oFnu",
	"./16_wandtapijtenreeks.yaml": "iBnn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YeqT";